import React, { useEffect, useState }  from 'react';
import '../Pages.css';



function MobilityCard({item, index}) {
    const imgLink = `./Images/${item.Image}`;
    const [focusID, setFocusID] = useState('');
    const [count, setCount] = useState(0);

    function getParent(elem) {
        setCount(count+1)
        let target = '';
        if (elem.id == '') {
            target = elem.offsetParent;
            getParent(target);
        } 
        else setFocusID(elem.id);
    };
    
    useEffect(()=> {
        if (focusID) document.getElementById(focusID).scrollIntoView({behavior:'smooth'});
    }, [focusID]);

    function MoveToCard(e) {getParent(e.target);};

    function openLink() { window.open(item.Link, '_blank'); };
    
    function addLink (hasLink) {
        if (hasLink) return <button className='mob-weblink' tabIndex={(index*2)+2} onClick={openLink}>{`${item.Name} website`}</button>;
    }

    return (
        <div className='mob-card info-card' tabIndex={(index*2)+1} id={`${item.Name.replaceAll(' ', '-')}-mob-card`} onClick={MoveToCard} >
            <h2 className='mob-name'>{item.Name ?? 'Mobility'}</h2>
            <div className="mob-body">
                <pre className='mob-desc'>{item.Description ?? 'Lorem ipsum...'}</pre>
                <div className="mob-side-box" >
                    <div className="mob-img-box">
                        <img className="mob-img" src={imgLink} alt={item.ImageDesc} />
                    </div>
                    {addLink(item.Link)}
                </div>
            </div>
        </div>
    )
}

export default MobilityCard